// extracted by css-extract-rspack-plugin
export default {"paper":"NavigationPopover_paper__YyJa6"};